export default __webpack_public_path__ + "static/media/Ask.67bb0de6.svg";